import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Card, Button, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Api from "../admin/components/api/Api";
import Notification, { showToast } from "../components/common/notification/Notification";

const ProfileForm = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [cities, setCities] = useState([]);
  const [isCityDisabled, setIsCityDisabled] = useState(true);
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;
  const userType = loggedInUser?.user?.userType?.name;
  // console.log(loggedInUser) 
  // console.log(userId) 
  console.log(userType) 

  const [profile, setProfile] = useState({id: userId,}); 
  const editDetailsApi = Api({ url: `admin/editUser` });
  const stateApi = Api({ url: `admin/states/${1}` });
  const cityApi = Api({ url: `admin/cities/${selectedState?.value}` });
  const serviceApi = Api({url: "all/services"});
  

  useEffect(() => {
    fetchStates();
    fetchCities();
    fetchServices();
  }, [selectedState]);

    const fetchServices = async () => {
      try {
        const responseData = await serviceApi.fetchDataBySingleId();
        setServices(responseData.data.services);
        console.log(services)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

  const fetchStates = async () => {
    try {
      const response = await stateApi.fetchData();
      if (response.data.statusType === "SUCCESS") {
        setStates(response.data.states);
        setIsCityDisabled(false);
      }
    } catch {
      setIsCityDisabled(true);
    }
  };

  const fetchCities = async () => {
    if (!isCityDisabled) {
      try {
        const response = await cityApi.fetchData();
        if (response.data.statusType === "SUCCESS") {
          setCities(response.data.cities);
        }
      } catch {
        setCities([]);
      }
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await editDetailsApi.editData(profile);
      console.log(responseData)
      console.log(loggedInUser.user)
      if (responseData.data.statusType === "SUCCESS") {
        showToast("User Edited Successfully", { type: "success" });
        navigate("/dashboard/myspace", { replace: true });
      }
    } catch {
      showToast("Error Occurred", { type: "error" });
    }
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center py-4"
      style={{
        background: "linear-gradient(130deg, #007bff38 0%, #6e42c144 100%)",
      }}
    >
      <Notification />
      <Row className="w-100 justify-content-center">
        <Col md={8} lg={6} sm={10} xl={4}>
          <Card className="shadow border-0 rounded-4">
            <Card.Body className="p-4">
              <h2 className="text-center fw-bold mb-2">Complete Your Profile</h2>
              <p className="text-center text-muted mb-3">
                Add your details or skip to continue
              </p>

              <Form onSubmit={handleProfileSubmit}>
                {/* First + Last Name in same row */}
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={profile.first_name || ""}
                        onChange={(e) =>
                          setProfile({ ...profile, first_name: e.target.value })
                        }
                        placeholder="Enter first name"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={profile.last_name || ""}
                        onChange={(e) =>
                          setProfile({ ...profile, last_name: e.target.value })
                        }
                        placeholder="Enter last name"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Email */}
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <InputGroup className="position-relative">
                    <Form.Control
                      type="email"
                      value={profile.email_address || ""}
                      onChange={(e) =>
                        setProfile({ ...profile, email_address: e.target.value })
                      }
                      placeholder="Enter email"
                      style={{ paddingRight: "2.5rem" }}
                    />
                  </InputGroup>
                </Form.Group>

                {/* State + City in same row */}
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>State</Form.Label>
                      <Form.Select
                        value={profile.state}
                        onChange={(e) => {
                          const selectedOption = e.target.selectedOptions[0];
                          setSelectedState(selectedOption);
                        }}
                      >
                        <option value="">Select state</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-5">
                      <Form.Label>City</Form.Label>
                      <Form.Select
                        value={profile.city}
                        onChange={(e) =>
                          setProfile({ ...profile, city_id: e.target.value })
                        }
                        disabled={isCityDisabled}
                      >
                        <option value="">Select city</option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  {userType === "PARTNER" && 
                    <Col md={6}>
                      <Form.Group className="mb-5">
                        <Form.Label>Service</Form.Label>
                        <Form.Select
                          value={profile.service}
                          onChange={(e) =>{
                            setProfile({ ...profile, service_id: e.target.value })
                            // console.log(profile)
                          }}
                        >
                          <option value="">Select Service</option>
                          {services.map((service) => (
                            <option key={service.id} value={service.id}>
                              {service.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  }
                </Row>

                {/* Buttons */}
                <div className="d-flex justify-content-between">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      navigate("/dashboard/myspace", { replace: true });
                      window.location.reload();
                    }}
                  >
                    Skip
                  </Button>
                  <Button type="submit" variant="primary">
                    Save & Continue
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfileForm;
